import { render, staticRenderFns } from "./crear-version.vue?vue&type=template&id=7b0a64f3&"
import script from "./crear-version.vue?vue&type=script&lang=js&"
export * from "./crear-version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports